/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a {{#isEngagement}}href="{{du}}?variant={{epi}}&rb=true"{{/isEngagement}}{{^isEngagement}}href="{{du}}"{{/isEngagement}}  aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1 text-center">
         {{dt}}
       </div>
     </button>
     <div class="swym-product-price swym-text swym-text-1 text-center">		
		<div class="swym-product-final-price swym-value text-center">
			{{cu}}{{pr}}
		</div>		 
     </div>	
     <button {{^isEngagement}} id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"{{/isEngagement}}  class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button" >
       {{#isInCart}}Added{{/isInCart}}{{^isInCart}}Add{{/isInCart}}
     </button>
   </a>
   {{/products}}
</div>`;
// `<product-ring-price data-compare-at-price="" data-base-price="" data-cut="" data-cut-info="{{vi}}" data-price-info="{{pr}}" data-url-info="{{du}}">
// <div class="price flex justify-content-center">
// <div class="from">From&nbsp;</div>
// <span class="compare"></span>
// <span class="final"></span>
// </div>
// </product-ring-price>	`
function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "Added";
      e.target.setAttribute("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.", c);
      location.href = "/cart";
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var wishlistContentsContainerTwo = document.getElementById(
      "wishlist-items-container-two"
    );
    var engagementHandles = document.querySelector("#engagement_handles")
      ? JSON.parse(document.querySelector("#engagement_handles").textContent)
      : [];
    var formattedWishlistedProducts = products.map(function (p) {
      console.log(p);
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isEngagement = false;
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (engagementHandles[0].handle && p.du) {
        if (engagementHandles[0].handle.find((er) => p.du.includes(er))) {
          p.isEngagement = true;
        }
      }
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer || wishlistContentsContainerTwo) {
      wishlistContentsContainer
        ? (wishlistContentsContainer.innerHTML = productCardsMarkup)
        : "";
      wishlistContentsContainerTwo
        ? (wishlistContentsContainerTwo.innerHTML = productCardsMarkup)
        : "";
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }

    setTimeout(() => {
      if (!products.length) {
        wishlistContentsContainer.innerHTML = `<p class="h4 text-center">You don’t have any saved items yet.</p>`;
      }
    }, 100);

    /*SAVE FOR LATER */
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
